export default __webpack_public_path__ + "static/lframe-commercial-vehicle-loan-428cef674e45ec9149af133a2e4cf435.png";